import { ICreateTermoBiometriaUseCase } from "../../../presentation/useCases/create/create_termo_biometria_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

export class CreateTermoBiometriaUseCase implements ICreateTermoBiometriaUseCase {
  constructor(private readonly repository: IRhRepository) {}

  async createTermoBiometria(
    idTermoEpi: number,
    idFuncionario: number,
    ativo: boolean,
    biometria: string | null,
  ): Promise<void> {
    await this.repository.createTermoBiometria(
      idTermoEpi,
      idFuncionario,
      ativo,
      biometria,
    );
  }
}
